import classNames from "classnames"
import PropTypes from "prop-types"
import React from "react"

import CellWithSubtitle from "src/components/Table/CellWithSubtitle"

const EMPTY_CELL_VALUE = "-"

const TableCell = ({
  align,
  children,
  className,
  title,
  subtitle,
  variant = "default",
  textSize = "default",
  colSpan = 1,
  columnWidth,
  onClick,
}) => {
  const renderCellContents = () => {
    if (title) {
      return (
        <CellWithSubtitle
          textSize={textSize}
          title={title}
          subtitle={subtitle}
          variant={variant}
        />
      )
    } else if (children) {
      return children
    } else {
      return EMPTY_CELL_VALUE
    }
  }

  return (
    <td
      className={classNames("px-4 group-[.is-infinite]:border-b", className)}
      align={align}
      colSpan={colSpan}
      style={columnWidth ? { width: columnWidth } : undefined}
      onClick={onClick}
    >
      {renderCellContents()}
    </td>
  )
}

TableCell.propTypes = {
  align: PropTypes.oneOf(["left", "right", "center", "justify"]),
  children: PropTypes.node,
  className: PropTypes.string,
  colSpan: PropTypes.number,
  columnWidth: PropTypes.string,
  onClick: PropTypes.func,
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  textSize: PropTypes.oneOf(["default", "xs"]),
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  variant: PropTypes.oneOf(["default", "strikethrough"]),
}

export default TableCell
